import React from 'react';
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import {useFormik} from "formik";
import {AuthService} from "../services/auth.service";
import axios from "axios";
import {StyledButton} from "../components/ui-base/button";
import {StyledInput} from "../components/form/input";
import * as Yup from "yup";
import LoginWrapper from "../components/login-wrapper";
import logoColor from "../img/logo-color.png";
import {Colors} from "../theme/colors";
import {useHistory, Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {StyledH2, StyledP2} from "../components/ui-base/styles";

const LoginSchema = Yup.object().shape({
    login: Yup.string()
        .email("inputEmailError")
        .required(),
    password: Yup.string()
        .required(),
});

const LoginPage = () => {
    const history = useHistory();
    const { t } = useTranslation('common');

    const loginForm = useFormik({
        initialValues: {
            login: '',
            password: ''
        },
        validationSchema: LoginSchema,
        onSubmit: async values => {
            const token = await AuthService.login(values.login, values.password);

            if (token) {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                history.push('/dashboard');
            }
        }
    });

    return (
        <LoginWrapper pageType={"login"} children={
            <>
                <StyledGridLogoContainer>
                    <StyledLogo src={logoColor} alt="Logo"/>
                </StyledGridLogoContainer>

                <StyledH2>{t('login.logIn')}</StyledH2>

                <StyledGridSmallLoginContainer container direction={"column"} style={{marginTop: '1rem'}}>
                    <form onSubmit={loginForm.handleSubmit} id="login-form" autoComplete={'false'}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                            spacing={2}
                        >
                            <StyledGridItemWrapper item>
                                <StyledInput
                                    id="login"
                                    label={t('login.inputNick')}
                                    onChange={loginForm.handleChange}
                                    value={loginForm.values.login}
                                    error={loginForm.errors.login && loginForm.touched.login}
                                />
                            </StyledGridItemWrapper>

                            <StyledGridItemWrapper item>
                                <StyledInput
                                    id="password"
                                    type="password"
                                    label={t('login.inputPassword')}
                                    onChange={loginForm.handleChange}
                                    value={loginForm.values.password}
                                    error={loginForm.errors.password && loginForm.touched.password}
                                />
                            </StyledGridItemWrapper>

                            <StyledGridItemWrapper item>
                                <StyledLoginP>{t('login.forgotPass')} <Link to="/remind-password">{t('login.resetPass')}</Link></StyledLoginP>
                            </StyledGridItemWrapper>

                            <StyledGridItemWrapper item>
                                <StyledButton type="submit" color={'primary'}>{t('login.logButton')}</StyledButton>
                            </StyledGridItemWrapper>
                        </Grid>
                    </form>
                </StyledGridSmallLoginContainer>
            </>
        } />
    );
};

const StyledGridItemWrapper = styled(Grid)`
  width: 100% !important;
  
  button {
    width: 100%;
  }
`;

const StyledGridLogoContainer = styled(Grid)`
  width: 100%;
  margin: 0 auto 1rem;
`;

const StyledLogo = styled('img')`
  height: 40px;
`;

const StyledGridSmallLoginContainer = styled(Grid)`
  max-width: 500px;
  margin: 0 auto;
`;

const StyledLoginP = styled(StyledP2)`
  color: ${Colors.neutral50};
  
  a {
    color: ${Colors.neutral50};
    text-decoration: underline;
  }
`;

export default LoginPage;
